import dayjs from 'dayjs'

export const DATE_NOW = Date.now()
export const TODAY = new Date()

export const getMonthNameAndYear = (date: Date, locale = 'en-us'): string => {
  return date.toLocaleDateString(locale, { month: 'long', year: 'numeric' })
}

export const isSameMonth = (a: Date, b: Date): boolean => {
  return a.getMonth() === b.getMonth()
}

export const getDateMonthStrDayShortYearFull = (date: string, placeholder = 'No due date set') => {
  return date && dayjs(date).isValid()
    ? Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).format(new Date(date))
    : placeholder
}

const day2DigitsMonthShort: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'short',
}

const day2DigitsMonth2DigitsYearNumeric: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
}

const day2DigitsMonthShortYearNumeric: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
}

const day2DigitsMonthLongYearNumeric: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
}

const month2DigitsDay2Digits: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
}

export const dateFormats = {
  day2DigitsMonth2DigitsYearNumeric,
  day2DigitsMonthShortYearNumeric,
  day2DigitsMonthShort,
  day2DigitsMonthLongYearNumeric,
  month2DigitsDay2Digits,
}

export const formatDate = <T extends Date | string>(date: T, format: keyof typeof dateFormats) => {
  return date && dayjs(date).isValid() ? new Date(date).toLocaleDateString('en-US', dateFormats[format]) : null
}

export function formatDateCustomSeparator(date: Date, separator: string) {
  return formatDate(date, 'day2DigitsMonth2DigitsYearNumeric')
    .split('')
    .map((char) => {
      if (char === '/') {
        return separator
      }
      return char
    })
    .join('')
}

type Day = string | number | Date | dayjs.Dayjs

export const getDayDifference = (leftDate: Day, rightDate: Day) => {
  return dayjs(leftDate).diff(rightDate, 'day')
}

export const addDays = (date: Day, count: number) => {
  const day = dayjs(date).add(count, 'day')

  if (typeof date === 'number') {
    return day.valueOf()
  }

  return day.toISOString()
}
